import React, { useState } from 'react'
import './AdsFormat.scss'
import Iphone01 from '../Assets/Images/iphone1.webp'
import Iphone02 from '../Assets/Images/iphone2.webp'
import Iphone03 from '../Assets/Images/iphone3.webp'
import Iphone04 from '../Assets/Images/iphone4.webp'
import { useLanguage } from '../Contexts/LanguageContext'

const AdsFormat = () => {
  // ✅ domyślnie aktywny pierwszy element
  const [activeIndex, setActiveIndex] = useState(0);

  const onEnter = (i) => () => setActiveIndex(i);
  const { language } = useLanguage();

  return (
    <div className='ads-format' id='format-reklam'>
      <div className='content desktop-only'>
        <div className='left'>
          <h2>{language === 'polish' ? 'Format reklam' : 'Ad Formats'}</h2>

          <div
            className={`ads-text ads-text01 ${activeIndex === 0 ? 'active-text-field' : ''}`}
            onMouseEnter={onEnter(0)}
            onFocus={onEnter(0)}
            tabIndex={0}
          >
            <h3>{language === 'polish' ? 'Reklamy pełnoekranowe' : 'Interstitial Ads'}</h3>
            <p>{language === 'polish' ? 'Format, który wypełnia cały ekran urządzenia – od smartfona po tablet – w momentach naturalnej przerwy w użytkowaniu aplikacji. Dzięki temu Twoja marka zyskuje absolutną uwagę odbiorcy, bez choćby jednej rozpraszającej ikonki czy pasku nawigacji.' : 'A format that fills the entire screen of the device – from smartphone to tablet – at moments of natural breaks in app usage. This gives your brand the absolute attention of the viewer, without a single distracting icon or navigation bar.'}</p>
          </div>

          <div
            className={`ads-text ads-text02 ${activeIndex === 1 ? 'active-text-field' : ''}`}
            onMouseEnter={onEnter(1)}
            onFocus={onEnter(1)}
            tabIndex={0}
          >
            <h3>{language === 'polish' ? 'Reklamy nagradzane' : 'Rewarded Ads'}</h3>
            <p>{language === 'polish' ? 'W przerwie w aplikacji (np. po zakończeniu poziomu) pokazuje się pełnoekranowe wideo. Po jego obejrzeniu (15–30 s) użytkownik otrzymuje bonus – dodatkowe życia, walutę czy dostęp do funkcji.' : 'During a break in the app (e.g., after completing a level), a fullscreen video is shown. After watching it (15–30 seconds), the user receives a bonus – extra lives, currency, or access to features.'}</p>
          </div>

          <div
            className={`ads-text ads-text03 ${activeIndex === 2 ? 'active-text-field' : ''}`}
            onMouseEnter={onEnter(2)}
            onFocus={onEnter(2)}
            tabIndex={0}
          >
            <h3>{language === 'polish' ? 'Reklamy banerowe' : 'Banner Ads'}</h3>
            <p>{language === 'polish' ? 'Umieszczone w strategicznych miejscach, dyskretne sloty reklamowe płynnie wkomponowują się w interfejs aplikacji. Użytkownik odbiera treść jako naturalny element, bez przerywania i frustracji, co zwiększa akceptację marki i wyniki kampanii.' : 'Placed in strategic locations, discreet ad slots seamlessly integrate into the app interface. The user perceives the content as a natural element, without interruption or frustration, increasing brand acceptance and campaign results.'}</p>
          </div>

          <div
            className={`ads-text ads-text04 ${activeIndex === 3 ? 'active-text-field' : ''}`}
            onMouseEnter={onEnter(3)}
            onFocus={onEnter(3)}
            tabIndex={0}
          >
            <h3>{language === 'polish' ? 'Posty sponsorowane' : 'Sponsored Posts'}</h3>
            <p>{language === 'polish' ? 'Reklama opublikowana na kanałach Telegrama trafia bezpośrednio do wyselekcjonowanych grup odbiorców, pojawiając się w strumieniu wiadomości co określoną liczbę postów, generując wysokie wskaźniki CTR, rozpoznawalność marki i konwersje.' : 'Ads published on Telegram channels reach selected target groups directly, appearing in the message stream after a certain number of posts, generating high CTR, brand recognition, and conversions.'}</p>
          </div>
        </div>

        <div className='right'>
          <div className='img-frame'>
            <img src={Iphone01} className={`img img01 ${activeIndex === 0 ? 'active' : ''}`} alt='iphone' />
            <img src={Iphone02} className={`img img02 ${activeIndex === 1 ? 'active' : ''}`} alt='iphone' />
            <img src={Iphone03} className={`img img03 ${activeIndex === 2 ? 'active' : ''}`} alt='iphone' />
            <img src={Iphone04} className={`img img04 ${activeIndex === 3 ? 'active' : ''}`} alt='iphone' />
          </div>
        </div>
      </div>
      <div className='mobile-only mobile-content'>
        <h2>Format reklam</h2>
        <div className='adds adds01'>
          <img src={Iphone01} className='iphone-img' alt='iphone' />
          <h3>Interstitial Ads</h3>
          <p>Format, który wypełnia cały ekran urządzenia – od smartfona po tablet – w momentach naturalnej przerwy w użytkowaniu aplikacji. Dzięki temu Twoja marka zyskuje absolutną uwagę odbiorcy, bez choćby jednej rozpraszającej ikonki czy pasku nawigacji.</p>
        </div>
        <div className='adds adds02'>
          
          <img src={Iphone02} className='iphone-img' alt='iphone' />
          <h3>Rewarded Ads</h3>
          <p>W przerwie w aplikacji (np. po zakończeniu poziomu) pokazuje się pełnoekranowe wideo. Po jego obejrzeniu (15–30 s) użytkownik otrzymuje bonus – dodatkowe życia, walutę czy dostęp do funkcji.</p> 
        </div>
        <div className='adds adds03'>
          <img src={Iphone03} className='iphone-img' alt='iphone' />
          <h3>Banner Ads</h3>
          <p>Umieszczone w strategicznych miejscach, dyskretne sloty reklamowe płynnie wkomponowują się w interfejs aplikacji. Użytkownik odbiera treść jako naturalny element, bez przerywania i frustracji, co zwiększa akceptację marki i wyniki kampanii.</p>
          </div>
        <div className='adds adds04'>
          <img src={Iphone04} className='iphone-img' alt='iphone' />
          <h3>Posty sponsorowane</h3>
          <p>Reklama opublikowana na kanałach Telegrama trafia bezpośrednio do wyselekcjonowanych grup odbiorców, pojawiając się w strumieniu wiadomości co określoną liczbę postów, generując wysokie wskaźniki CTR, rozpoznawalność marki i konwersje.</p>
        </div>
      </div>
    </div>
  )
}

export default AdsFormat
